import React, { useMemo } from 'react';
import { Box, Typography, Button, Stack, Pagination, PaginationItem } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { canPerformAction, ActionKey } from '../../auth/actionMatrix';
import AnimatedPage from '../../components/AnimatedPage';
import RequisitesTable from './components/RequisitesTable';
import RequisiteForm from './components/RequisiteForm';
import RequisiteFilters from './components/RequisiteFilters';
import { useRequisites } from './hooks/useRequisites';

export default function Requisites() {
  const currentUser = useSelector((state: RootState) => state.auth.user);
  const canCreate = useMemo(() => canPerformAction(currentUser, ActionKey.REQUISITES_CREATE), [currentUser]);

  const {
    requisites,
    traders,
    paymentSystems,
    banks,
    error,
    success,
    loading,
    totalPages,
    filters,
    handleFilterChange,
    handleSearch,
    open,
    editingRequisite,
    formData,
    setFormData,
    handleOpen,
    handleClose,
    handleSubmit,
    handleDelete,
    handleToggleActive,
    handleUnblock,
    handleResetFilters,
    handlePageChange,
  } = useRequisites();

  return (
    <AnimatedPage>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            Реквизиты
          </Typography>
          {canCreate ? (
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>
              Добавить реквизиты
            </Button>
          ) : null}
        </Box>

        <RequisiteFilters
          filters={filters}
          traders={traders}
          paymentSystems={paymentSystems}
          onFilterChange={handleFilterChange}
          onSearch={handleSearch}
          onReset={handleResetFilters}
        />

        <RequisitesTable
          requisites={requisites}
          traders={traders}
          paymentSystems={paymentSystems}
          banks={banks}
          loading={loading}
          error={error}
          onEdit={handleOpen}
          onDelete={handleDelete}
          onToggleActive={handleToggleActive}
          onUnblock={handleUnblock}
        />

        {totalPages > 1 && (
          <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
            <Pagination
              count={totalPages}
              page={filters.page}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
              renderItem={(item) => <PaginationItem {...item} disabled={item.page === filters.page} />}
            />
          </Stack>
        )}

        <RequisiteForm
          open={open}
          onClose={handleClose}
          onSubmit={handleSubmit}
          editingRequisite={editingRequisite}
          formData={formData}
          setFormData={setFormData}
          traders={traders}
          paymentSystems={paymentSystems}
          banks={banks}
        />
      </Box>
    </AnimatedPage>
  );
}
